function load_specs(specs_fname) {
  var specs = require("json-loader!yaml-loader!../specs/" + specs_fname);
  if (specs.did_parse) {
    return specs;
  }
  for (let parsing_rule in specs.parsing_rules) {
    var newRule = [];
    for (let sub_rule of specs.parsing_rules[parsing_rule]) {
      newRule.push(eval(sub_rule));
    }
    specs.parsing_rules[parsing_rule] = newRule;
  }
  for (let field of specs.fields) {
    if (field.parsing_rules) {
      field.parsing_rules = specs.parsing_rules[field.parsing_rules];
    }
  }
  specs.did_parse = true;
  return specs;
}

export default load_specs;
